/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_User_DisabledInputs */

const en_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account has been disabled.`)
};

const fr_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte a été désactivé.`)
};

const de_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Konto wurde deaktiviert.`)
};

const it_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo account è stato disabilitato.`)
};

const ru_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот аккаунт заблокирован.`)
};

const es_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta cuenta ha sido deshabilitada.`)
};

const zh_cn2_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此账户已被禁用。`)
};

const ja_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントは無効になっています。`)
};

const hi_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह खाता बंद कर दिया गया है।`)
};

const pt_pt2_login_error_user_disabled = /** @type {(inputs: Login_Error_User_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conta foi desativada.`)
};

/**
* | output |
* | --- |
* | "This account has been disabled." |
*
* @param {Login_Error_User_DisabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_user_disabled = /** @type {((inputs?: Login_Error_User_DisabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_User_DisabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_user_disabled(inputs)
	if (locale === "de") return de_login_error_user_disabled(inputs)
	if (locale === "it") return it_login_error_user_disabled(inputs)
	if (locale === "ru") return ru_login_error_user_disabled(inputs)
	if (locale === "es") return es_login_error_user_disabled(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_user_disabled(inputs)
	if (locale === "ja") return ja_login_error_user_disabled(inputs)
	if (locale === "hi") return hi_login_error_user_disabled(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_user_disabled(inputs)
	return en_login_error_user_disabled(inputs)
});